var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "#CEE4FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.068 56.113c-.23-.076-1.668-1.553-.768-4.33h-.012c2.345-2.452 4.352-6.396 4.352-10.283 0-5.97-4.129-9.102-8.675-9.102-4.55 0-8.496 3.131-8.496 9.102 0 3.9 1.839 7.861 4.196 10.311.919 2.447-.724 4.172-1.069 4.302-4.76 1.746-10.346 4.935-10.346 8.08v1.179c0 4.286 8.185 5.26 15.76 5.26 7.585 0 15.668-.974 15.668-5.26v-1.18c0-3.24-5.614-6.401-10.61-8.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.703 48.24c-.213-.072-1.568-.403-.722-3.016h-.01c2.204-2.302 3.725-6.016 3.725-9.665 0-5.615-3.517-8.559-7.791-8.559-3.147 0-5.857 1.607-7.074 4.686 2.554 2.11 4.31 5.392 4.31 9.813 0 4.72-2.211 9.026-4.525 11.805 3.686 1.395 9.445 4.2 11.093 8.488 5.807-.322 10.971-1.528 10.971-4.85v-1.107c-.002-3.045-5.28-6.019-9.977-7.595z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 18,
    y: 20,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTeam);
export default __webpack_public_path__ + "static/media/ic-team.a5f610b0c3f469b48a25cfe2257d649a.svg";
export { ForwardRef as ReactComponent };